import t from "./SearchInput.vue_rollup-plugin-vue=script.js";
export default (function (t, e, n, r, o, a, i, s) {
  var u = ("function" == typeof n ? n.options : n) || {};
  return u.__file = "SearchInput.vue", u.render || (u.render = t.render, u.staticRenderFns = t.staticRenderFns, u._compiled = !0, o && (u.functional = !0)), u._scopeId = r, u;
})({
  render: function render() {
    var t = this,
        e = t.$createElement,
        n = t._self._c || e;
    return n("form", {
      class: t.suit("form"),
      attrs: {
        action: "",
        role: "search",
        novalidate: ""
      },
      on: {
        submit: function submit(e) {
          return e.preventDefault(), t.onFormSubmit.apply(null, arguments);
        },
        reset: function reset(e) {
          return e.preventDefault(), t.onFormReset.apply(null, arguments);
        }
      }
    }, [n("input", {
      ref: "input",
      class: t.suit("input"),
      attrs: {
        type: "search",
        autocorrect: "off",
        autocapitalize: "off",
        autocomplete: "off",
        spellcheck: "false",
        maxlength: "512",
        "aria-label": "Search",
        placeholder: t.placeholder,
        autofocus: t.autofocus
      },
      domProps: {
        value: t.value || t.modelValue
      },
      on: {
        focus: function focus(e) {
          return t.$emit("focus", e);
        },
        blur: function blur(e) {
          return t.$emit("blur", e);
        },
        input: function input(e) {
          return t.onInput(e);
        },
        compositionend: function compositionend(e) {
          return t.onInput(e);
        }
      }
    }), t._v(" "), n("button", {
      class: t.suit("submit"),
      attrs: {
        type: "submit",
        title: t.submitTitle,
        hidden: t.showLoadingIndicator && t.shouldShowLoadingIndicator
      }
    }, [t._t("submit-icon", function () {
      return [n("svg", {
        class: t.suit("submitIcon"),
        attrs: {
          "aria-hidden": "true",
          width: "10",
          height: "10",
          viewBox: "0 0 40 40"
        }
      }, [n("path", {
        attrs: {
          d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
        }
      })])];
    })], 2), t._v(" "), n("button", {
      class: t.suit("reset"),
      attrs: {
        type: "reset",
        title: t.resetTitle,
        hidden: !t.value && !t.modelValue || t.showLoadingIndicator && t.shouldShowLoadingIndicator
      }
    }, [t._t("reset-icon", function () {
      return [n("svg", {
        class: t.suit("resetIcon"),
        attrs: {
          "aria-hidden": "true",
          height: "10",
          viewBox: "0 0 20 20",
          width: "10"
        }
      }, [n("path", {
        attrs: {
          d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
        }
      })])];
    })], 2), t._v(" "), t.showLoadingIndicator ? n("span", {
      class: t.suit("loadingIndicator"),
      attrs: {
        hidden: !t.shouldShowLoadingIndicator
      }
    }, [t._t("loading-indicator", function () {
      return [n("svg", {
        class: t.suit("loadingIcon"),
        attrs: {
          "aria-hidden": !t.shouldShowLoadingIndicator,
          "aria-label": "Results are loading",
          width: "16",
          height: "16",
          stroke: "#444",
          viewBox: "0 0 38 38"
        }
      }, [n("g", {
        attrs: {
          fill: "none",
          "fill-rule": "evenodd"
        }
      }, [n("g", {
        attrs: {
          transform: "translate(1 1)",
          "stroke-width": "2"
        }
      }, [n("circle", {
        attrs: {
          "stroke-opacity": ".5",
          cx: "18",
          cy: "18",
          r: "18"
        }
      }), t._v(" "), n("path", {
        attrs: {
          d: "M36 18c0-9.94-8.06-18-18-18"
        }
      }, [n("animateTransform", {
        attrs: {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        }
      })], 1)])])])];
    })], 2) : t._e()]);
  },
  staticRenderFns: []
}, 0, t, void 0, !1);